export default __webpack_public_path__ + "static/media/Date picker-bro.fcf22065.svg";